var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M0 14C3.86583 10.1341 10.1342 10.1341 14 14C10.1342 17.8658 3.86583 17.8658 0 14ZM14 14C17.8658 17.8658 24.1342 17.8658 28 14C24.1123 10.1341 17.8658 10.1341 14 14Z",
    fill: "#EE3F2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.0009 28C10.1351 24.1342 10.1351 17.8658 14.0009 14C17.8668 17.8658 17.8668 24.1342 14.0009 28ZM14.0009 14C17.8668 10.1342 17.8668 3.86583 14.0009 0C10.1351 3.86583 10.1351 10.1342 14.0009 14Z",
    fill: "#FED624"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.08398 23.894C4.08398 18.4338 8.51768 14.0001 13.9779 14.0001C13.9997 19.4603 9.56604 23.894 4.08398 23.894ZM13.9997 14.0001C19.46 14.0001 23.8937 9.56642 23.8937 4.1062C18.4116 4.1062 13.9997 8.51806 13.9997 14.0001Z",
    fill: "#F68A1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.08398 4.1062C9.5442 4.1062 13.9779 8.5399 13.9779 14.0001C8.51768 14.0001 4.08398 9.56642 4.08398 4.1062ZM13.9997 14.0001C13.9997 19.4603 18.4334 23.894 23.8937 23.894C23.8937 18.4338 19.46 14.0001 13.9997 14.0001Z",
    fill: "#FDC125"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M0 14C3.86583 10.1341 10.1342 10.1341 14 14C10.1342 17.8658 3.86583 17.8658 0 14ZM14 14C17.8658 17.8658 24.1342 17.8658 28 14C24.1123 10.1341 17.8658 10.1341 14 14Z",
    fill: "#EE3F2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.0009 28C10.1351 24.1342 10.1351 17.8658 14.0009 14C17.8668 17.8658 17.8668 24.1342 14.0009 28ZM14.0009 14C17.8668 10.1342 17.8668 3.86583 14.0009 0C10.1351 3.86583 10.1351 10.1342 14.0009 14Z",
    fill: "#FED624"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.08398 23.894C4.08398 18.4338 8.51768 14.0001 13.9779 14.0001C13.9997 19.4603 9.56604 23.894 4.08398 23.894ZM13.9997 14.0001C19.46 14.0001 23.8937 9.56642 23.8937 4.1062C18.4116 4.1062 13.9997 8.51806 13.9997 14.0001Z",
    fill: "#F68A1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.08398 4.1062C9.5442 4.1062 13.9779 8.5399 13.9779 14.0001C8.51768 14.0001 4.08398 9.56642 4.08398 4.1062ZM13.9997 14.0001C13.9997 19.4603 18.4334 23.894 23.8937 23.894C23.8937 18.4338 19.46 14.0001 13.9997 14.0001Z",
    fill: "#FDC125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany09);
export default __webpack_public_path__ + "static/media/company-09.3247d1b24207d3e8d842eabca414daf6.svg";
export { ForwardRef as ReactComponent };